import api from "./core";

const basePath = "api/core/Providers";

export default {
  query(filter, extraHeaders = {}) {
    return api.post(`${basePath}`, filter, extraHeaders);
  },
  updateProvider(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  removeProvider(id) {
    return api.patch(`${basePath}/RemoveProvider/${id}`);
  }
};
